module.exports = __webpack_public_path__ + "static/Youper-13d5c85335bd846d025e361b4750e901.jpg";